import React, { ReactElement } from 'react';
import { Text } from 'idsk-react-components';
import RezortneZbierkyListRow from './PrispevokVestnikaListRow';
import PrispevokVestnikaListPage from '../../../model/PrispevokVestnikaListPage';

interface Props {
  prispevokVestnikaPage: PrispevokVestnikaListPage;
  isSelectedFilter: boolean;
}

const PrispevokVestnikaListComponent = ({
  prispevokVestnikaPage,
  isSelectedFilter,
}: Props): ReactElement => {
  if (prispevokVestnikaPage.totalElements === 0 && isSelectedFilter) {
    return (
      <Text type="p" size="l" className="text-center">Nenašli sa žiadne príspevky zodpovedajúce zvolenému filtru.</Text>
    );
  }

  if (prispevokVestnikaPage.totalElements === 0) {
    return <Text type="p" size="l" className="text-center">Neexistujú žiadne príspevky.</Text>;
  }

  if (prispevokVestnikaPage.totalElements > 0 && prispevokVestnikaPage.prispevokList.length === 0) {
    return (
      <Text type="p" size="l" className="text-center">
        Na aktuálnej stránke sa nenachádzajú žiadne príspevky.
      </Text>
    );
  }

  return (
    <>
      {prispevokVestnikaPage.prispevokList.map((prispevok) => (
        <RezortneZbierkyListRow rezortnaZbierka={prispevok} key={prispevok.uuid} />
      ))}
    </>
  );
};

export default PrispevokVestnikaListComponent;
